export const articles = [
  {
    slug: 'aiye-video-app-xiazai-anjiao',
    title: '爱液视频App下载安装完整教程（2025最新版）',
    excerpt: '本文将详细介绍爱液视频App在Android和iOS设备上的下载和安装步骤，帮助您快速完成安装，开始享受海量高清视频内容。',
    content: `<h2>一、爱液视频App简介</h2>
<p>爱液视频App是一款集海量高清视频资源、流畅播放体验和智能推荐算法于一体的综合性视频平台。无论您是喜欢电影、电视剧、综艺、动漫还是短视频，爱液视频App都能满足您的观看需求。</p>
<p>平台拥有超过10万小时的高清视频内容库，每日更新超过500条新鲜内容，覆盖娱乐、教育、体育、纪录片等多个领域。</p>
<h2>二、Android设备下载安装教程</h2>
<h3>2.1 官方渠道下载</h3>
<p>为确保下载安全，请务必通过以下官方渠道获取安装包：</p>
<ol>
<li>访问爱液视频官方网站（aiyeshipin.com）</li>
<li>点击首页"Android下载"按钮</li>
<li>等待APK安装包下载完成</li>
</ol>
<h3>2.2 安装步骤</h3>
<ol>
<li>打开手机"设置" > "安全"</li>
<li>开启"允许安装未知来源应用"选项</li>
<li>找到下载的APK文件并点击安装</li>
<li>等待安装完成，点击"打开"即可使用</li>
</ol>
<h2>三、iOS设备下载安装教程</h2>
<h3>3.1 App Store下载</h3>
<p>iOS用户可以直接在App Store中搜索"爱液视频"进行下载：</p>
<ol>
<li>打开App Store应用</li>
<li>在搜索栏输入"爱液视频"</li>
<li>找到官方应用并点击"获取"</li>
<li>验证Apple ID后自动安装</li>
</ol>
<h2>四、安装后设置建议</h2>
<p>安装完成后，建议进行以下设置以获得最佳体验：</p>
<ul>
<li>注册/登录账号以同步观看记录</li>
<li>选择感兴趣的内容标签以优化推荐</li>
<li>在WiFi环境下设置离线缓存</li>
<li>调整画质偏好（流畅/高清/超清）</li>
</ul>
<h2>五、常见安装问题</h2>
<p><strong>Q: 安装时提示"解析包错误"怎么办？</strong></p>
<p>A: 请重新下载安装包，确保下载完整。如果问题持续，请检查手机系统版本是否兼容。</p>
<p><strong>Q: iOS下载后无法打开？</strong></p>
<p>A: 请在"设置" > "通用" > "设备管理"中信任企业级应用证书。</p>`,
    category: 'jiaocheng',
    categoryName: '使用教程',
    author: '爱液视频官方',
    date: '2025-12-15',
    readTime: '8分钟',
    views: 15680,
    tags: ['下载', '安装', '教程', '新手'],
    imageSeq: 'article-install-01',
  },
  {
    slug: 'aiye-video-app-shiyong-jiqiao',
    title: '爱液视频App十大实用技巧，让你的观影体验飞升',
    excerpt: '掌握这些实用的使用技巧，让你更高效地使用爱液视频App，发现更多精彩内容，享受前所未有的观影体验。',
    content: `<h2>技巧一：个性化推荐调教</h2>
<p>在"我的"页面中，点击"偏好设置"，选择您感兴趣的内容类别。系统会根据您的选择优化推荐算法，让推荐内容更加精准。</p>
<p>建议至少选择3-5个兴趣标签，这样推荐效果最佳。</p>
<h2>技巧二：离线缓存功能</h2>
<p>在WiFi环境下，您可以提前将喜欢的视频缓存到本地。点击视频下方的"缓存"按钮，选择清晰度即可。缓存视频支持离线播放，节省流量。</p>
<h2>技巧三：多设备同步观看</h2>
<p>登录同一账号，手机、平板、电脑之间的观看记录、收藏列表和播放进度会自动同步，实现无缝切换。</p>
<h2>技巧四：弹幕互动</h2>
<p>观看视频时开启弹幕功能，与其他观众实时互动。您可以发送弹幕、点赞别人的弹幕，还可以设置弹幕透明度、速度和显示区域。</p>
<h2>技巧五：视频清晰度自适应</h2>
<p>App会根据您当前的网络状况自动调整视频清晰度。您也可以手动选择流畅、高清或超清模式。</p>
<h2>技巧六：创建播放列表</h2>
<p>将喜欢的视频添加到自定义播放列表中，打造专属的观影频道。支持创建多个播放列表进行分类管理。</p>
<h2>技巧七：定时关闭</h2>
<p>睡前追剧必备！设置定时关闭功能，到达设定时间后自动停止播放，不用担心看过头。</p>
<h2>技巧八：倍速播放</h2>
<p>支持0.5倍到2倍速播放，学习类视频可以放慢细看，拖沓剧情可以快进浏览。</p>
<h2>技巧九：手势控制</h2>
<p>播放界面支持手势操作：左侧上下滑动调节亮度，右侧上下滑动调节音量，左右滑动快进快退。</p>
<h2>技巧十：分享功能</h2>
<p>看到好内容？一键分享给好友，支持微信、QQ、微博等多种分享渠道。</p>`,
    category: 'jiqiao',
    categoryName: '使用技巧',
    author: '爱液视频官方',
    date: '2025-11-28',
    readTime: '10分钟',
    views: 23450,
    tags: ['技巧', '实用', '体验', '高效'],
    imageSeq: 'article-tips-01',
  },
  {
    slug: 'aiye-video-app-gongneng-xiangjie',
    title: '爱液视频App功能全面解析：不止是视频播放器',
    excerpt: '深度解析爱液视频App的每一项功能特色，从智能推荐到社区互动，带你全面了解这款强大的视频平台。',
    content: `<h2>一、核心播放功能</h2>
<h3>1.1 高清流畅播放</h3>
<p>采用先进的视频编码技术和CDN加速，确保在各种网络环境下都能流畅播放。支持1080P、4K超高清画质。</p>
<h3>1.2 多格式兼容</h3>
<p>支持MP4、MKV、AVI、FLV等主流视频格式，无需转换即可直接播放。</p>
<h3>1.3 悬浮窗播放</h3>
<p>支持小窗口悬浮播放，边看视频边聊天、浏览网页，一屏多用。</p>
<h2>二、智能推荐系统</h2>
<h3>2.1 AI算法推荐</h3>
<p>基于深度学习算法，分析您的观看历史、收藏偏好和停留时长，精准推送您可能感兴趣的内容。</p>
<h3>2.2 热门榜单</h3>
<p>实时更新的热门榜单，包含日榜、周榜和总榜，帮您发现最受欢迎的内容。</p>
<h3>2.3 相关推荐</h3>
<p>在视频详情页展示相关内容，扩展您的观影视野。</p>
<h2>三、社交互动功能</h2>
<h3>3.1 弹幕系统</h3>
<p>实时弹幕互动，支持彩色弹幕、顶部弹幕、底部弹幕等多种模式。</p>
<h3>3.2 评论区</h3>
<p>在视频下方发表评论，与其他用户交流观影感受。</p>
<h3>3.3 收藏与点赞</h3>
<p>一键收藏喜欢的视频，点赞精彩内容，构建个人观影档案。</p>
<h2>四、账号体系</h2>
<h3>4.1 多端同步</h3>
<p>手机、平板、电脑多端数据实时同步，随时随地继续观看。</p>
<h3>4.2 会员特权</h3>
<p>会员用户享受去广告、超清画质、独家内容等专属特权。</p>
<h3>4.3 家长控制</h3>
<p>设置观看时长限制和内容过滤，为孩子创造安全的观影环境。</p>`,
    category: 'gongneng',
    categoryName: '功能介绍',
    author: '爱液视频官方',
    date: '2025-11-15',
    readTime: '12分钟',
    views: 18920,
    tags: ['功能', '特色', '智能', '社交'],
    imageSeq: 'article-features-01',
  },
  {
    slug: 'aiye-video-app-huiyuan-quanyi',
    title: '爱液视频App会员权益详解：到底值不值得买？',
    excerpt: '详细对比爱液视频App免费版与会员版的差异，分析各项会员权益的实际价值，帮你做出最明智的选择。',
    content: `<h2>一、会员类型介绍</h2>
<h3>1.1 月度会员</h3>
<p>适合短期体验，价格为19.9元/月，自动续费可随时取消。</p>
<h3>1.2 季度会员</h3>
<p>性价比较高，49.9元/季度（相当于16.6元/月），节省17%。</p>
<h3>1.3 年度会员</h3>
<p>最优惠方案，168元/年（相当于14元/月），节省30%。还额外赠送3个月，实际享15个月。</p>
<h2>二、核心会员权益</h2>
<h3>2.1 去广告体验</h3>
<p>会员用户观看视频时完全无广告打扰，包括片头广告、暂停广告和贴片广告。</p>
<h3>2.2 超清画质</h3>
<p>会员可享受4K超高清画质和HDR色彩增强，观影体验大幅提升。</p>
<h3>2.3 独家内容</h3>
<p>部分热门影视剧、综艺节目仅限会员观看，内容库更丰富。</p>
<h3>2.4 离线缓存</h3>
<p>会员支持同时缓存10部视频，非会员仅支持3部。</p>
<h3>2.5 多设备同时登录</h3>
<p>会员支持最多5台设备同时在线，全家共享一个账号。</p>
<h2>三、免费版功能对比</h2>
<table>
<tr><th>功能</th><th>免费版</th><th>会员版</th></tr>
<tr><td>视频画质</td><td>最高1080P</td><td>最高4K HDR</td></tr>
<tr><td>广告</td><td>有广告</td><td>无广告</td></tr>
<tr><td>离线缓存</td><td>3部</td><td>10部</td></tr>
<tr><td>多设备登录</td><td>2台</td><td>5台</td></tr>
<tr><td>独家内容</td><td>不可看</td><td>可看</td></tr>
<tr><td>弹幕特权</td><td>普通弹幕</td><td>彩色+特效弹幕</td></tr>
</table>
<h2>四、购买建议</h2>
<p>如果您是重度视频用户，每天观看时间超过1小时，强烈推荐购买年度会员，性价比最高。如果只是偶尔使用，免费版也完全够用。</p>`,
    category: 'gongneng',
    categoryName: '功能介绍',
    author: '爱液视频官方',
    date: '2025-10-20',
    readTime: '7分钟',
    views: 31200,
    tags: ['会员', '权益', '对比', '价格'],
    imageSeq: 'article-vip-01',
  },
  {
    slug: 'aiye-video-app-changjian-wenti',
    title: '爱液视频App常见问题解答（FAQ合集）',
    excerpt: '汇总用户最常遇到的问题和解决方案，包括账号注册、播放异常、充值退款等各类问题的详细解答。',
    content: `<h2>一、账号相关问题</h2>
<h3>Q: 如何注册账号？</h3>
<p>A: 打开App后点击"我的" > "登录/注册"，支持手机号、微信、QQ三种方式注册。手机号注册需验证短信验证码。</p>
<h3>Q: 忘记密码怎么办？</h3>
<p>A: 在登录页面点击"忘记密码"，通过绑定的手机号或邮箱重置密码。</p>
<h3>Q: 可以注销账号吗？</h3>
<p>A: 在"设置" > "账号安全" > "注销账号"中操作。注意注销后所有数据将被清除且不可恢复。</p>
<h2>二、播放相关问题</h2>
<h3>Q: 视频加载慢怎么办？</h3>
<p>A: 请尝试：1) 切换网络环境；2) 降低视频清晰度；3) 清理App缓存；4) 重启App。</p>
<h3>Q: 为什么有些视频无法播放？</h3>
<p>A: 可能是版权限制或内容下架导致。如遇到播放问题，可以点击"反馈"按钮告知我们。</p>
<h3>Q: 支持投屏吗？</h3>
<p>A: 支持！在播放页面点击投屏图标，选择可用的投屏设备即可。支持DLNA和AirPlay协议。</p>
<h2>三、充值退款问题</h2>
<h3>Q: 如何充值会员？</h3>
<p>A: 点击"我的" > "会员中心"，选择套餐后通过微信支付或支付宝完成付款。</p>
<h3>Q: 会员自动续费怎么取消？</h3>
<p>A: 在对应支付平台（微信/支付宝）的"免密支付/自动扣款"中取消授权即可。</p>
<h3>Q: 充值后可以退款吗？</h3>
<p>A: 虚拟商品原则上不支持退款。如遇特殊情况请联系客服处理。</p>
<h2>四、其他问题</h2>
<h3>Q: App占用空间太大怎么办？</h3>
<p>A: 在"设置" > "清理缓存"中清理临时文件和缓存数据。已缓存的视频也可以选择性删除。</p>
<h3>Q: 如何联系客服？</h3>
<p>A: 在App内"我的" > "帮助与反馈"中联系在线客服，或发送邮件至support@aiyeshipin.com。</p>`,
    category: 'wenti',
    categoryName: '常见问题',
    author: '爱液视频官方',
    date: '2025-12-01',
    readTime: '9分钟',
    views: 27800,
    tags: ['FAQ', '问题', '帮助', '客服'],
    imageSeq: 'article-faq-01',
  },
  {
    slug: 'aiye-video-app-anzhuo-anzhuang',
    title: 'Android用户专属：爱液视频App安装常见问题解决',
    excerpt: '针对Android用户安装爱液视频App时可能遇到的各种问题，提供详细的排查步骤和解决方案。',
    content: `<h2>一、安装前准备</h2>
<h3>1.1 系统要求</h3>
<p>爱液视频App支持Android 7.0及以上系统版本，建议使用Android 10及以上以获得最佳体验。最低需要2GB运行内存和200MB可用存储空间。</p>
<h3>1.2 安全设置</h3>
<p>安装前需要在"设置" > "安全"中开启"允许安装未知来源应用"。不同品牌的手机路径可能略有不同：</p>
<ul>
<li>华为：设置 > 安全 > 更多安全设置 > 外部来源应用安装</li>
<li>小米：设置 > 隐私保护 > 特殊权限 > 安装未知应用</li>
<li>OPPO：设置 > 安全 > 安装外部来源应用</li>
<li>vivo：设置 > 安全与隐私 > 安装未知应用</li>
</ul>
<h2>二、常见安装问题</h2>
<h3>2.1 "解析包时出现问题"</h3>
<p>原因和解决方案：</p>
<ul>
<li>下载的APK文件不完整 → 重新下载</li>
<li>系统版本过低 → 升级系统或使用旧版App</li>
<li>APK与设备架构不兼容 → 确认下载正确版本（ARM64/ARMv7）</li>
</ul>
<h3>2.2 "应用未安装"</h3>
<p>可能原因：</p>
<ul>
<li>存储空间不足 → 清理手机空间</li>
<li>已安装签名冲突版本 → 先卸载旧版本</li>
<li>系统安全策略限制 → 关闭安全防护后重试</li>
</ul>
<h3>2.3 "安装被阻止"</h3>
<p>华为、小米等品牌手机会有额外的安全检测，请在弹出提示时选择"继续安装"或"信任此应用"。</p>
<h2>三、安装后问题</h2>
<h3>3.1 App闪退</h3>
<p>尝试以下方法：清除App缓存数据、重启手机、重新安装App。</p>
<h3>3.2 无法联网</h3>
<p>检查App的网络权限是否开启："设置" > "应用管理" > "爱液视频" > "权限" > 开启网络权限。</p>`,
    category: 'jiaocheng',
    categoryName: '使用教程',
    author: '爱液视频官方',
    date: '2025-11-05',
    readTime: '6分钟',
    views: 12340,
    tags: ['Android', '安装', '问题', '修复'],
    imageSeq: 'article-android-01',
  },
];

export const getArticleBySlug = (slug: string) => {
  return articles.find((a) => a.slug === slug);
};

export const getArticlesByCategory = (category: string) => {
  return articles.filter((a) => a.category === category);
};

export const getRelatedArticles = (currentSlug: string, limit: number = 3) => {
  const current = articles.find((a) => a.slug === currentSlug);
  if (!current) return [];
  return articles
    .filter((a) => a.slug !== currentSlug && a.category === current.category)
    .slice(0, limit);
};